import StereotypesStore, { getFieldType } from "../StereotypesStore";
import { getImplementations } from "../selectors/stereotypes";
import { getKeyPrefix } from "jsmodel/utils";
import recordLabel from "data/selectors/recordLabel";

class StereotypeProxy {

    constructor(access, keyOrInfo, id) {
        if (keyOrInfo.hasOwnProperty("key")) {
            this.stereoInfo = keyOrInfo;
            this.stereoKey = this.stereoInfo.key;
        } else {
            this.stereoKey = keyOrInfo;
            this.stereoInfo = StereotypesStore.getStereotypeByKey(this.stereoKey);
        }
        this.access = access;
        this.id = id;
    }

    getAttributeType(field) {
        return getFieldType(this.stereoInfo, field);
    }

    get(field) {
        const self = this;
        // get record implementations
        let impls = getImplementations(this.stereoInfo, this.access, self.id);
        impls = this.entityContext ?
              impls.filter(impl => getKeyPrefix(impl.key) === this.entityContext) :
              impls;
        const values = _.compact(impls.map(impl => {
            const fi = impl.fieldImpls.find(fi => fi.key === field);
            if (fi == null) return null;
            return fi.script(self.access.getEntityProxy(impl.key, self.id));
        }));
        if (_.isEmpty(values)) return null;
        return values.sort()[0];
    }

    getKey() {
        return this.stereoKey + "#" + this.id;
    }

    equals(o) {
        if (o == null) return false;
        if (!(o instanceof StereotypeProxy)) return false;
        if (this.stereoKey !== o.stereoKey) return false;
        if (this.id !== o.id) return false;
        return true;
    }

    getLabel() {
        return recordLabel(this.stereoInfo, this);
    }

    getDetailString() {
        if (this.stereoInfo.scripts.hasOwnProperty("toDetailString")) {
            return this.stereoInfo.scripts.toDetailString(this);
        }
        return null;
    }

    withEntityContext(entityKey) {
        this.entityContext = getKeyPrefix(entityKey);
    }

}

export default StereotypeProxy;



// WEBPACK FOOTER //
// ./app/data/util/StereotypeProxy.js